import MOA from "../../assets/MoA.pdf";
function AboutModal() {
    
    return (
        <>
            <div
                className="modal fade"
                id="aboutModal"
                tabIndex="-1"
                aria-labelledby="aboutModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="aboutModalLabel">Terms and Conditions</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: "80vh", overflowY: "auto" }}>
                            {/* Embed the PDF inside an iframe */}
                            <iframe
                                src={MOA}
                                width="100%"
                                height="650px"
                                title="Terms and Conditions PDF"
                            ></iframe>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutModal;
